<script>
    import { t } from '$lib/i18n.js';
    import SearchBar from '$lib/components/SearchBar.svelte';
</script>

<div class="full-width" style="margin-bottom: -5px;">
    <svg
        viewBox="0 0 1512 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M509.513 21.1174C682.763 21.1174 740.25 6.09447 867.431 6.09447C994.613 6.09447 1002.49 35.567 1225.35 28.9156C1448.21 22.2642 1512 50.5898 1512 50.5898H0C0 50.5898 107.888 0.589845 233.494 0.589844C359.1 0.589843 336.263 21.1174 509.513 21.1174Z"
            fill="#F5F3ED"
        />
    </svg>
</div>
<section class="branding">
    <div class="col">
        <img class="logo" src="https://assets.auting.it/images/logo/logo.svg" alt="Auting Logo" />
        <h2>{$t('components.footer.branding_section.claim')}</h2>
        <p>{$t('components.footer.branding_section.description')}</p>
        <SearchBar />
    </div>
    <img class="full-width" src="https://assets.auting.it/images/waves/footer/waves_and_city.svg" alt="Logo" />
</section>

<style>
    .full-width {
        width: 100vw;
        margin: 0;
    }

    .branding {
        position: relative;
        width: 100vw;
        margin: 0;
        padding: 0;
        background-color: var(--surface-container);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 0px;
        padding-bottom: 130px;
        box-sizing: border-box;
        min-height: 888px;
    }

    .branding img.logo {
        width: 120px;
        height: auto;
        margin-bottom: 40px;
    }

    .branding p {
        text-align: center;
        max-width: 575px;
        
    }

    .branding h2 {
        margin-bottom: 16px;
        text-align: center;
    }

    .branding .full-width {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100vw;
        height: auto;
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
    }

    @media (max-width: 768px) {
        .branding {
            min-height: 60vh;
            padding-bottom: 200px;
            padding-top: 80px;
            padding-left: 16px;
            padding-right: 16px;
        }

        .branding p {
            font-size: 16px;
        }
    }
</style>